import React from 'react';

import { useAppConfig } from '#/config/AppConfigContext';
import { getMockFile } from '#/hooks/useUpload/getMockFile';

import {
  ImagePickerDropzoneInternal,
  type ImagePickerDropzoneProps,
} from './ImagePickerDropzoneInternal';

export function ImagePickerDropzone(props: ImagePickerDropzoneProps) {
  const { onDrop, ...restProps } = props;

  const { appConfig } = useAppConfig();
  const isFilestackMock = appConfig.filestack.mock;

  const getDroppedFile = isFilestackMock
    ? getMockFile
    : (e: React.DragEvent) => Promise.resolve(e.dataTransfer.files[0]);

  const triggerClick = isFilestackMock
    ? async (e: React.UIEvent) => {
        e.preventDefault();
        onDrop(await getMockFile());
      }
    : (e: React.UIEvent, fileInput: HTMLInputElement) => {
        e.preventDefault();
        fileInput.click();
      };

  return (
    <ImagePickerDropzoneInternal
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
      onDrop={onDrop}
      getDroppedFile={getDroppedFile}
      triggerClick={triggerClick}
    />
  );
}
